const isRisingTalent = ({ params, isHandpicked }) =>
    isHandpicked && params.rising_talent;

module.exports = {
    isRisingTalent
};
